import { ENV } from '../constants';
import { getThemeAssetUrl } from './theme-assets';
import { isThemeableLayout, type TLayout } from '../types/layout';
import { DEFAULT_THEME_ID, type ThemeId } from '../types/theme';

export const BUILD_THEME_ID: ThemeId = ENV.THEME;

export function getEffectiveThemeId(layout: TLayout): ThemeId {
  if (!isThemeableLayout(layout)) {
    return DEFAULT_THEME_ID;
  }

  return BUILD_THEME_ID;
}

export function getThemedAssetUrl(layout: TLayout, assetName: string): string {
  return getThemeAssetUrl(getEffectiveThemeId(layout), assetName);
}

export function isThemingEnabled(layout: TLayout): boolean {
  return isThemeableLayout(layout);
}
